import type { DataImportErrorsResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetDataImportErrorsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetDataImportErrorsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetDataImportErrorsArgs = {
  dataImportId: string;
};

export const useGetDataImportErrors = createQueryHook<
  UseGetDataImportErrorsArgs,
  DataImportErrorsResponseRow[],
  GetDataImportErrorsQuery
>({
  trpcQueryOptions: (trpc, { dataImportId }) =>
    trpc.frontend.dataImport.dataImportErrors.queryOptions({ dataImportId }),
  mapTrpcDataToGraphQL: (data) => ({ data_import_error: data }),
  graphqlDocument: GetDataImportErrorsDocument,
  graphqlVariables: ({ dataImportId }) => ({ dataImportId }),
});
